// extracted by mini-css-extract-plugin
export var collapsedSummary = "_so-0";